import React from "react";
import {
  Box,
  Flex,
  Text,
  SimpleGrid,
  List,
  ListItem,
  Image,
  UnorderedList,
  Button,
} from "@chakra-ui/react";
import Banner from "../../assets/homeImage/banner.png";
import GradientTextWithStroke from "../../components/StyledText/StyledText";

import Prize from "../../assets/rewardsImage/prize.png";
import Bonus from "../../assets/rewardsImage/bonus.png";
import Refer from "../../assets/rewardsImage/refer.png";
import Power from "../../assets/rewardsImage/power.png";
import Private from "../../assets/rewardsImage/private.png";

import Welcome from "../../assets/rewardsImage/welcome.png";
import Rewards from "../../assets/rewardsImage/rewards.png";
import Tournament from "../../assets/rewardsImage/tournament.png";
import Together from "../../assets/rewardsImage/together.png";
import Lucky from "../../assets/rewardsImage/lucky.png";

import Login from "../../assets/rewardsImage/login.png";
import Level from "../../assets/rewardsImage/level.png";
import Leader from "../../assets/rewardsImage/leader.png";
import Flash from "../../assets/rewardsImage/flash.png";
import Invite from "../../assets/rewardsImage/invite.png";

import Starter from "../../assets/rewardsImage/starter.png";
import Cash from "../../assets/rewardsImage/cash.png";
import Skill from "../../assets/rewardsImage/skill.png";
import Festival from "../../assets/rewardsImage/festival.png";

import Tier from "../../assets/rewardsImage/tier.png";
import Benefit from "../../assets/rewardsImage/benefit.png";

const How = () => {
  const cards1 = [
    {
      icon: Prize,
      title: "Contest Prizes:",
      points: [
        "Win in Top 1, Top 3, Top10, or Top 50%",
        "Daily Mega Leagues with BIG payouts",
      ],
    },
    {
      icon: Bonus,
      title: "First-Time Bonus:",
      points: ["₹100 Signup Bonus", "100% Match up to ₹1,000"],
    },
    {
      icon: Refer,
      title: "Refer & Earn:",
      points: ["₹100 + ₹50 per referral", "10% lifetime commission"],
    },
    {
      icon: Power,
      title: "Power Bonuses:",
      points: [
        "Bonus XP for team streaks",
        "Flash bonuses during IPL, WC, EPL",
      ],
    },
    {
      icon: Private,
      title: "Private Leagues:",
      points: ["Host with friends, earn bonus cash"],
    },
  ];

  const cards2 = [
    {
      icon: Welcome,
      title: "Welcome Pack:",
      points: ["1,000 Free Chips", "Deposit Match up to ₹5,000"],
    },
    {
      icon: Rewards,
      title: "Table Rewards:",
      points: ["Royal Flush = Bonus", "Daily Challenges = Extra Chips"],
    },
    {
      icon: Tournament,
      title: "Tournaments:",
      points: ["Weekly Leaderboards", "Chip Multipliers on buy-ins"],
    },
    {
      icon: Together,
      title: "Refer & Play Together:",
      points: ["₹100 + 500 Chips per invite", "Play with 3+ referral"],
    },
    {
      icon: Lucky,
      title: "Lucky Draws:",
      points: ["Spin wheel after 5 games, Win Buy-Ins or Chip Boosts"],
    },
  ];

  const cards3 = [
    {
      icon: Login,
      title: "Login Rewards:",
      points: ["Daily Coins & Boosters", "Mystery Boxes for active players"],
    },
    {
      icon: Level,
      title: "XP & Level Bonus:",
      points: ["XP per win", "Unlock jackpots, avatars"],
    },
    {
      icon: Leader,
      title: "Leaderboards:",
      points: ["Weekly Top 10 = prizes", "Vouchers, coupons, premium skins"],
    },
    {
      icon: Flash,
      title: "Flash Events:",
      points: ["2x Coins for wins", "Limited-time boost rounds"],
    },
    {
      icon: Invite,
      title: "Invite & Earn:",
      points: ["₹25 per Arcade invite, Extra when friend hits 1000 XP"],
    },
  ];

  const cards4 = [
    {
      icon: Starter,
      title: "Starter Pack:",
      points: [
        "₹100 Signup + ₹50 on Email Verify",
        "Deposit Bonus up to ₹3,000",
      ],
    },
    {
      icon: Cash,
      title: "Cash Tables:",
      points: [
        "Win in Pool, Points & Deal formats",
        "10 games streak = cashback",
      ],
    },
    {
      icon: Skill,
      title: "Skill Bonuses:",
      points: ["3 Wins = Instant Bonus", "Loss streak = Safety Cashback"],
    },
    {
      icon: Invite,
      title: "Invite Bonus:",
      points: [
        "₹100 when your friend plays 3 games",
        "Extra ₹200 when they win ₹500+",
      ],
    },
    {
      icon: Festival,
      title: "Festival & VIP Perks:",
      points: [
        "Festive tables with mega payouts",
        "VIP = double chips + faster payouts",
      ],
    },
  ];

  const cards5 = [
    {
      icon: Tier,
      title: "Level Up Tiers:",
      points: ["Silver → Gold → Platinum → Diamond", "Earn XP on every play"],
    },
    {
      icon: Cash,
      title: "Tier Benefits:",
      points: [
        "Fast Withdrawals",
        "Festival Gifts & Free Entry Passes",
        "VIP-Only Tables",
        "Priority Support",
      ],
    },
  ];

  return (
    <Box bg="#17161B" overflowX="hidden">
      {/* Banner */}
      <Box
        bgImage={`url(${Banner})`}
        bgSize="cover"
        bgPosition="center"
        w="100%"
        h={{ base: "300px", md: "469px" }}
        color="white"
        // pr="100px"
      >
        <Flex direction="column" justify="center" align="center" h="100%">
          <Box textAlign="center">
            <GradientTextWithStroke
              text="Rewards & Offers"
              desktopFontSize={70}
              mobileFontSize={60}
              strokeColor="#5c2d06"
              strokeWidth={5}
              gradientStops={[
                { offset: "25%", color: "#FAECA4" },
                { offset: "100%", color: "#B5763A" },
              ]}
            />
            <Text
              fontSize={{ base: "16px", md: "25px" }}
              fontStyle="italic"
              fontWeight="500"
              letterSpacing="0.2em"
              mt="-10px"
            >
              One App. All Games. Infinite Rewards.
            </Text>
          </Box>
        </Flex>
      </Box>

      {/* 🎮 Fantasy Sports Section */}
      <Box px={{ base: 4, md: 12 }} py={{ base: 8, md: 12 }}>
        <Text
          textAlign="center"
          fontSize={{ base: "24px", md: "40px" }}
          mb={2}
          color="#FFFFFF"
        >
          FANTASY SPORTS
        </Text>
        <Text
          textAlign="center"
          fontSize={{ base: "16px", md: "24px" }}
          fontStyle="italic"
          mb={8}
          color="#D9982A"
        >
          (Cricket, Football, Kabaddi)
        </Text>

        <SimpleGrid
          columns={{ base: 1, sm: 2, md: 3, lg: 5 }}
          spacing={{ base: 4, md: 6 }}
          justifyItems="center"
        >
          {cards1.map((card, idx) => (
            <Box
              key={idx}
              {...cardStyle}
              w="250px"
              h="191px"
              display="flex"
              flexDirection="column"
            >
              <Flex align="center" mb={2}>
                <Image src={card.icon} alt={card.title} width="20%" />
                <Text ml={2} color={"white"} fontSize="20px">
                  {card.title}
                </Text>
              </Flex>
              <UnorderedList
                spacing={1}
                fontSize="18px"
                color="#A1A1A1"
                textAlign={"justify"}
              >
                {card.points.map((point, i) => (
                  <ListItem key={i}>{point}</ListItem>
                ))}
              </UnorderedList>
            </Box>
          ))}
        </SimpleGrid>
      </Box>

      {/* 🎮 POKER & TEEN PATTI Section */}
      <Box px={{ base: 4, md: 12 }} py={{ base: 8, md: 12 }}>
        <Text
          textAlign="center"
          fontSize={{ base: "24px", md: "40px" }}
          pb="50px"
          color="#FFFFFF"
        >
          POKER & TEEN PATTI
        </Text>

        <SimpleGrid
          columns={{ base: 1, sm: 2, md: 3, lg: 5 }}
          spacing={{ base: 4, md: 6 }}
          justifyItems="center"
        >
          {cards2.map((card, idx) => (
            <Box
              key={idx}
              {...cardStyle}
              w="250px"
              h="191px"
              display="flex"
              flexDirection="column"
            >
              <Flex align="center" mb={2}>
                <Image src={card.icon} alt={card.title} width="20%" />
                <Text ml={2} color={"white"} fontSize="20px">
                  {card.title}
                </Text>
              </Flex>
              <UnorderedList
                spacing={1}
                fontSize="18px"
                color="#A1A1A1"
                textAlign={"justify"}
              >
                {card.points.map((point, i) => (
                  <ListItem key={i}>{point}</ListItem>
                ))}
              </UnorderedList>
            </Box>
          ))}
        </SimpleGrid>
      </Box>

      {/* 🎮 ARCADE GAMES Section */}
      <Box px={{ base: 4, md: 12 }} py={{ base: 8, md: 12 }}>
        <Text
          textAlign="center"
          fontSize={{ base: "24px", md: "40px" }}
          mb={2}
          color="#FFFFFF"
        >
          ARCADE GAMES
        </Text>
        <Text
          textAlign="center"
          fontSize={{ base: "16px", md: "24px" }}
          fontStyle="italic"
          mb={8}
          color="#D9982A"
        >
          (Ludo, Pool, Candy Crush, Knife Hit, etc.)
        </Text>

        <SimpleGrid
          columns={{ base: 1, sm: 2, md: 3, lg: 5 }}
          spacing={{ base: 4, md: 6 }}
          justifyItems="center"
        >
          {cards3.map((card, idx) => (
            <Box
              key={idx}
              {...cardStyle}
              w="250px"
              h="191px"
              display="flex"
              flexDirection="column"
            >
              <Flex align="center" mb={2}>
                <Image src={card.icon} alt={card.title} width="20%" />
                <Text ml={2} color={"white"} fontSize="20px">
                  {card.title}
                </Text>
              </Flex>
              <UnorderedList
                spacing={1}
                fontSize="18px"
                color="#A1A1A1"
                textAlign={"justify"}
              >
                {card.points.map((point, i) => (
                  <ListItem key={i}>{point}</ListItem>
                ))}
              </UnorderedList>
            </Box>
          ))}
        </SimpleGrid>
      </Box>

      {/* 🎮 RUMMY GAMES Section */}
      <Box px={{ base: 4, md: 12 }} py={{ base: 8, md: 12 }}>
        <Text
          textAlign="center"
          fontSize={{ base: "24px", md: "40px" }}
          mb={2}
          color="#FFFFFF"
        >
          RUMMY
        </Text>

        <SimpleGrid
          columns={{ base: 1, sm: 2, md: 3, lg: 5 }}
          spacing={{ base: 4, md: 6 }}
          justifyItems="center"
        >
          {cards4.map((card, idx) => (
            <Box
              key={idx}
              {...cardStyle}
              w="250px"
              h="191px"
              display="flex"
              flexDirection="column"
            >
              <Flex align="center" mb={2}>
                <Image src={card.icon} alt={card.title} width="20%" />
                <Text ml={2} color={"white"} fontSize="20px">
                  {card.title}
                </Text>
              </Flex>
              <UnorderedList
                spacing={1}
                fontSize="18px"
                color="#A1A1A1"
                textAlign={"justify"}
              >
                {card.points.map((point, i) => (
                  <ListItem key={i}>{point}</ListItem>
                ))}
              </UnorderedList>
            </Box>
          ))}
        </SimpleGrid>
      </Box>

      {/* 🎮 LOYALTY & VIP Section */}
      <Box px={{ base: 4, md: 12 }} py={{ base: 8, md: 12 }}>
        <Text
          textAlign="center"
          fontSize={{ base: "24px", md: "40px" }}
          mb={2}
          color="#FFFFFF"
        >
          LOYALTY & VIP
        </Text>
        <Text
          textAlign="center"
          fontSize={{ base: "16px", md: "24px" }}
          fontStyle="italic"
          mb={8}
          color="#D9982A"
        >
          (All Games)
        </Text>

        <Flex
          wrap="wrap"
          justify="center"
          gap="50px" // exact horizontal and vertical gap between boxes
        >
          {cards5.map((card, idx) => (
            <Box
              key={idx}
              {...cardStyle}
              w="370px"
              h="191px"
              display="flex"
              flexDirection="column"
            >
              <Flex align="center" mb={2}>
                <Image src={card.icon} alt={card.title} width="10%" />
                <Text ml={2} color="white" fontSize="20px">
                  {card.title}
                </Text>
              </Flex>
              <UnorderedList
                spacing={1}
                fontSize="18px"
                color="#A1A1A1"
                textAlign="justify"
              >
                {card.points.map((point, i) => (
                  <ListItem key={i}>{point}</ListItem>
                ))}
              </UnorderedList>
            </Box>
          ))}
        </Flex>

        <Box
          bg="#17161B"
          px={{ base: 4, md: 8 }}
          py={{ base: 8, md: 12 }}
          textAlign="center"
        >
          {/* 🎯 First Line */}
          <Text
            fontSize={{ base: "24px", md: "35px" }}
            fontStyle="italic"
            fontWeight="500"
            color="#FFC072"
            mb={4}
          >
            PLAY. WIN. REWARD. REPEAT.
          </Text>

          {/* 🎯 Second Line */}
          <Text fontSize={{ base: "20px", md: "30px" }} color="#FFFFFF" mb={6}>
            Bonus packs, XP boosts, VIP perks—every tap counts.
          </Text>

          {/* 🎯 Third Line with Button */}
          <Flex
            justify="center"
            align="center"
            fontSize={{ base: "20px", md: "30px" }}
            color="#FFFFFF"
            wrap="wrap"
          >
            <Text mr={2}>Tap</Text>
            <Button
              bgGradient="linear(to-b, #D9982A, #C98319)"
              color="black"
              fontWeight="bold"
              px={{ base: 4, md: 6 }}
              py={{ base: 2, md: 3 }}
              mx={2}
              _hover={{ bgGradient: "linear(to-b, #D9982A, #C98319)" }}
            >
              Start Playing
            </Button>
            <Text ml={2}>and climb the leaderboard!</Text>
          </Flex>
        </Box>
      </Box>
    </Box>
  );
};

// Shared card border style
const cardStyle = {
  position: "relative",
  bg: "#24232A",
  p: { base: 4, md: 6 },
  borderRadius: "10px",
  overflow: "hidden",
  _before: {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    borderRadius: "10px",
    padding: "1px",
    background:
      "linear-gradient(235.22deg, rgba(255, 209, 153, 0.1) -31.4%, #D9982A -12.83%, rgba(255, 209, 153, 0.1) 6.39%, #D9982A 24.96%, rgba(255, 209, 153, 0.1) 46.73%, #D9982A 69.15%, rgba(255, 209, 153, 0.1) 96.69%)",
    WebkitMask:
      "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
    WebkitMaskComposite: "xor",
    maskComposite: "exclude",
    pointerEvents: "none",
    zIndex: 1,
  },
};

const titleStyle = {
  fontSize: { base: "20px", md: "30px" },
  fontWeight: "500",
  mb: 2,
  color: "#D9982A",
};

const descStyle = {
  fontSize: { base: "16px", md: "28px" },
  color: "#FFFFFFCC",
  whiteSpace: "pre-line",
};

export default How;
